// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkTypePickerPanel[data-v-7e2b0fe0]{width:100%;margin-top:-1px;overflow:hidden;border:1px solid var(--link-line-strong,#e0e0e0);border-top:none;border-radius:0 0 var(--link-radius-lg,16px) var(--link-radius-lg,16px);background:var(--link-card-surface,#fff);box-shadow:var(--link-shadow-lg,0 12px 32px rgba(0,0,0,.08))}", ""]);
// Exports
module.exports = exports;
